import { render } from "./ReviPOSPlanModal.vue?vue&type=template&id=8d3b169c&scoped=true"
import script from "./ReviPOSPlanModal.vue?vue&type=script&lang=js"
export * from "./ReviPOSPlanModal.vue?vue&type=script&lang=js"

import "./ReviPOSPlanModal.vue?vue&type=style&index=0&id=8d3b169c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8d3b169c"

export default script